<div>
    <optsol-ngx-spinner></optsol-ngx-spinner>
    <router-outlet></router-outlet>
</div>
